import { Injectable } from '@angular/core';

import { AvailableOffersState } from './available-offers.state';

@Injectable({
  providedIn: 'root'
})
export class AvailableOffersPersistenceService {
  private readonly STORAGE_KEY = 'umarketplace_available_offers';

  saveToLocalStorage(state: AvailableOffersState): void {
    try {
      if (state.rawResponse) {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
          rawResponse: state.rawResponse,
          msisdnsByVariation: state.msisdnsByVariation || {},
          lastUpdated: state.lastUpdated
        }));
      }
    } catch (error) {
      console.error('[AvailableOffersPersistence] Erro ao salvar:', error);
    }
  }

  loadFromLocalStorage(): Partial<AvailableOffersState> | null {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        const data = JSON.parse(stored);
        return {
          rawResponse: data.rawResponse,
          msisdnsByVariation: data.msisdnsByVariation || {},
          lastUpdated: data.lastUpdated || null
        };
      }
    } catch (error) {
      console.error('[AvailableOffersPersistence] Erro ao carregar:', error);
    }
    return null;
  }

  clearFromLocalStorage(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('[AvailableOffersPersistence] Erro ao limpar:', error);
    }
  }

  hasStoredData(): boolean {
    try {
      return localStorage.getItem(this.STORAGE_KEY) !== null;
    } catch {
      return false;
    }
  }
}

